import React, { useEffect,useRef } from "react";
import { connect } from "react-redux";
import { withClientstoreService } from "../hoc";
import {
    fetchBookform,
    setCurrentFormId,
    setCurrentCompId,
    setCurrentRecordId,
    setCurrentUserPhone,
    setHiddenMaster,
    setCurrentCityId,
    serviceCartClear,
    fetchEmployees,
    employeeAddedToCart,
    getRecordById,
    setUserPhone,
} from "../../actions";
import SnackbarNotify from "../snackbar-notify";
import CircularProgress from "@mui/material/CircularProgress";
import SkeletonMainPage from "../skeletons/SkeletonMainPage";
import { fetchServices, serviceAddedToCart } from "../../actions";

// const Bookform = (props) => {
//     const { setFormID , getBookForm , bookform , loading , error , formId} = props;
//
//     // useEffect(() => {
//     //     let obj = {
//     //         formId
//     //     }
//     //     setFormID(formId);
//     //     //console.log(obj);
//     //     getBookForm(obj);
//     // } , []);
//
//     return (
//         <div>
//
//         </div>
//     );
// };

const Bookform = (props) => {
    const {
        formId,
        bookform: { bookform, form_id, loading, error },
        setFormID,
        setCompID,
        setCityID,
        setRecId,
        getBookForm,
        getLoading,
        employees,
        eLoading,
        filialsShow,
        clearRedux,
        cartClear,
        fetchEmployees,
        setHiddenMaster,
        getStaffName,
        recordId,
        typeAction,
        recordInfo,
        uPhone,
        setUserYCPhone,
        setPhone,
        tgid,
        serviceId,
    } = props;

    // const steps = bookform.data.steps;
    const baseStaffName = {
        nominative: "Специалист",
        genitive: "Специалиста",
        plural: "Специалисты",
    };

    // Настройки формы ЮК / если отключен выбор мастера
    const steps = bookform.data ? bookform.data.steps : [];
    const staff_name = bookform.data ? bookform.data.staff_name : baseStaffName;

    // получаем настройки для названия специалистов из ЮК формы
    useEffect(() => {
        // console.log("1 >" , staff_name );
        if (staff_name.plural !== "Специалисты") {
            // console.log("2 >>" , staff_name );
            getStaffName(staff_name);
        }
    }, [staff_name]);

    useEffect(() => {
        const masterStep = steps.filter((el) => el.step === "master");
        let hiddenMasterStep = false;
        let masterId = 0;

        if (Array.isArray(masterStep) && masterStep.length > 0) {
            hiddenMasterStep = masterStep[0]["hidden"];
            masterId = masterStep[0]["default"];

            if (hiddenMasterStep) {
                setHiddenMaster(hiddenMasterStep);
                // готовим фильтр
                const objFilter = {
                    id: undefined,
                    company_id: bookform.data.company_id,
                    datetime: "",
                    services: [],
                    term: "",
                    defMasterId: masterId,
                };

                fetchEmployees(objFilter);
            }
        }
    }, [steps]);

    // useEffect(() => {
    //     if(parseInt(bookform.data.group_id ) > 0){
    //         filialsShow(true);
    //     }
    // } , [bookform])

    const handleReset = () => {
        // console.log("reset handle");
        cartClear();
    };

    // useEffect(() => {
    //
    //     if(clearRedux){
    //
    //         // очистим корзину в редакс если человек открыл другую форму
    //         handleReset();
    //         localStorage.clear();
    //         console.log("klocal" , localStorage.getItem("serviceCart.serviceCartItems"));
    //
    //     }
    // } , [clearRedux])

    useEffect(() => {
        if (clearRedux) {
            // очистим корзину в редакс если человек открыл другую форму
            handleReset();
            // localStorage.clear();
            // console.log("klocal" , localStorage.getItem("serviceCart.serviceCartItems"));
        }

        if (formId) {
            let obj = {
                formId,
                tgid,
            };
            // console.log("OBJ >>>>" , obj);
            setFormID(formId);

            // console.log('serviceId',serviceId)

            // // ждем, пока bookform.data и servicesList будут загружены
            // if (serviceId && bookform.data && bookform.data.services) {
            //     console.log("Добавляем сервис в корзину", serviceId);
            //     props.onAddedToCart(serviceId);
            // }
            // если перенос записи
            if (recordId) {
                // если передется ID записи для переноса, то получаем информацию по записи чтобы заполнить Корзину
                // console.log("RECC" , recordId);
                let act = "move";
                if (typeAction === "reorder") act = "reorder";
                setRecId({ id: recordId, action: act });
                recordInfo({ shop_id: formId, record_id: recordId });
            }
            // если передан номер телефона
            if (uPhone) {
                console.log("bool uPhone", uPhone);
                setUserYCPhone(uPhone); // это запись номера в bookform
                const fields = {
                    uname: "",
                    phone: `+${uPhone}`,
                };
                setPhone(fields); // это чтобы в форму автоматом подставилось
            }
            // console.log(obj);
            getBookForm(obj);
        } else {
            if (!bookform.success) {
                throw new Error("invalid shop id");
            }
        }
    }, []);

    useEffect(() => {
        // console.log("use effect bookform" , loading);
        getLoading(loading);
        // console.log("Array.isArray(bookform)" , Object.prototype.toString.call(bookform) === '[object Object]');
    }, [loading]);

    useEffect(() => {
        if (Object.prototype.toString.call(bookform) === "[object Object]") {
            const gr_id = parseInt(bookform.data.group_id);
            if (gr_id > 0) {
                filialsShow(true);
            }
        }
    }, [bookform]);

    // useEffect(() => {
    //         // console.log('serviceId',serviceId)
    //         console.log('serviceId',serviceId)
    //         console.log('serviceId  bookform.data', bookform.data)

    //     if (serviceId && bookform.data) {
    //          props.fetchServices({
    //             id: 0,
    //             datetime: '',
    //             services: [],
    //             term: '',
    //             company_id: bookform.data.company_id,
    //             tgid,
    //         });
    //         console.log("Добавляем сервис в корзину", serviceId);
    //         props.onAddedToCart(serviceId);
    //     }
    // }, [serviceId, bookform.data]);



 // --- 1) сохраняем первый пришедший serviceId в ref, чтобы он не потерялся ---
  const initialServiceIdRef = useRef(null);
  useEffect(() => {
    if (!initialServiceIdRef.current && serviceId) {
      initialServiceIdRef.current = serviceId;
      console.log("сохранили initialServiceId:", initialServiceIdRef.current);
    }
  }, [serviceId]);

  // В дальнейшем используем targetServiceId (первый пришедший, если есть)
  const targetServiceId = initialServiceIdRef.current || serviceId;

  // --- 2) companyId (как раньше) ---
  const companyIdFromBookform = bookform && bookform.data && bookform.data.company_id
    ? bookform.data.company_id
    : null;

  // --- 3) вызываем fetchServices, когда есть companyId и targetServiceId ---
  useEffect(() => {
    if (!targetServiceId || !companyIdFromBookform) {
      console.log("не запускаем fetchServices: serviceId", targetServiceId, "companyId", companyIdFromBookform);
      return;
    }

    console.log("INIT fetchServices for companyId =", companyIdFromBookform, "serviceId =", targetServiceId);

    props.fetchServices({
      id: 0,
      datetime: "",
      services: [],
      term: "",
      company_id: companyIdFromBookform,
      tgid: tgid || 0,
    });
  }, [targetServiceId, companyIdFromBookform, tgid]);

  // --- 4) добавляем в корзину только когда servicesList загружен и сервис найден; добавляем ровно 1 раз ---
  const addedRef = useRef(false);

  // Сбрасываем флаг добавления, если сменился целевой id (например, пришла новая ссылка)
  useEffect(() => {
    addedRef.current = false;
  }, [targetServiceId]);

  useEffect(() => {
    if (!targetServiceId || !props.servicesList) return;

    const { loading, services: servicesBlock } = props.servicesList;
    if (loading) {
      // ещё загружается
      return;
    }

    // Получаем массив услуг из блоков (варианты структуры поддержаны)
    let arServices = [];
    if (Array.isArray(servicesBlock)) {
      arServices = servicesBlock;
    } else if (servicesBlock && Array.isArray(servicesBlock.services)) {
      arServices = servicesBlock.services;
    }

    if (!arServices.length) {
      console.log("servicesList загружен, но массив пуст");
      return;
    }

    const found = arServices.find(s => s && s.id === targetServiceId);
    if (!found) {
      console.log("Сервис с id не найден:", targetServiceId);
      return;
    }

    if (!addedRef.current) {
      console.log("Добавляем сервис в корзину:", targetServiceId, found.title || "(no title)");
      props.onAddedToCart(targetServiceId);
      addedRef.current = true;
    }
  },
  // зависимости: targetServiceId + маркеры загрузки/данных servicesList
  [targetServiceId, props.servicesList && props.servicesList.loading, props.servicesList && props.servicesList.services]);



    // console.log("BookFCont" , `=> ${formId} => ${form_id}`);
    // <SnackbarNotify variant="error" message="Не передан Shop ID " boolOpen={true}/>

    // if(bookform.bookform.data.company_id){
    //      // throw new Error("Произошла ошибка");
    //     return <CircularProgress />
    // }

    return null;

    // return(
    //
    //     <div>ФОРМА {formId}</div>
    // );
};

const mapStateToProps = (state) => {
    const {
        bookform,
        loading,
        error,
        employeeList,
        tguserdata,
        servicesList,
    } = state;
    console.log("tguserdata", tguserdata);
    return {
        bookform,
        success: bookform.success,
        loading,
        error,
        form_id: bookform.form_id,
        city_id: bookform.city_id,
        comp_id: bookform.comp_id,
        // record_id : bookform.record_id ,
        employees: employeeList.employees,
        eLoading: employeeList.loading,
        eError: employeeList.error,
        tgid: tguserdata.user ? tguserdata.user.id : "",
        // servicesList: services,
        servicesList,
    };
};
const mapDispatchToProps = (dispatch, { clientstoreService }) => {
    //const  = ownProps;
    return {
        setPhone: (fields) => dispatch(setUserPhone(fields)),
        getBookForm: fetchBookform(clientstoreService, dispatch),
        setFormID: (form_id) => dispatch(setCurrentFormId(form_id)),
        setCityID: (city_id) => dispatch(setCurrentCityId(city_id)),
        setCompID: (comp_id) => dispatch(setCurrentCompId(comp_id)),
        setRecId: (rec_id) => dispatch(setCurrentRecordId(rec_id)),
        setUserYCPhone: (phone) => dispatch(setCurrentUserPhone(phone)),
        setHiddenMaster: (hid) => dispatch(setHiddenMaster(hid)),
        cartClear: () => dispatch(serviceCartClear()),
        fetchEmployees: fetchEmployees(clientstoreService, dispatch),
        recordInfo: getRecordById(clientstoreService, dispatch),
        onAddedToCart: (serviceId) => dispatch(serviceAddedToCart(serviceId)),
        fetchServices: fetchServices(clientstoreService, dispatch),
    };
};

export default withClientstoreService()(
    connect(mapStateToProps, mapDispatchToProps)(Bookform)
);
